import { IonContent, IonPage } from '@ionic/react';
import React from 'react';

import { PaywallSectionPaymentOnPage } from '@/pages/Paywall/sections/PaymentOnPage';

import './PaywallV1.scss';
import { OnboardingPaywallSectionAccessList } from './sections/AccessList';
import { OnboardingPaywallSectionGoPremium } from './sections/GoPremium';
import { OnboardingPaywallSectionImages } from './sections/Images';
import { OnboardingPaywallImagination } from './sections/Imagination';
import { OnboardingPaywallSectionReviews } from './sections/Reviews';
import { OnboardingPaywallSectionTimer } from './sections/Timer';

const PaywallV1: React.FC = () => {
  return (
    <IonPage className="onboarding-paywall-v1">
      <IonContent>
        <OnboardingPaywallSectionImages />

        <OnboardingPaywallSectionGoPremium />

        <OnboardingPaywallSectionAccessList />

        <OnboardingPaywallSectionReviews />

        <OnboardingPaywallImagination />

        <OnboardingPaywallSectionTimer />

        <PaywallSectionPaymentOnPage withSafeness />
      </IonContent>
    </IonPage>
  );
};

export default PaywallV1;
